module.exports = __webpack_public_path__ + "img/fw_workflow_5.5353b53c.png";